import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import PageNotFound from "../../../Component/NotFound/index";
import BioMetric from "../Biometric";
import Gps from "../Gps";
import Attendance from "./Attendance";
import AttendanceDashboard from "./Attendance/Dashboard";
import Holiday from "./Holiday";
import SelectHoliday from "./Holiday/SelectOptionalHoliday";
import Leaves from "./Leaves";
import LeaveDashboard from "./Leaves/Dashboard";
import MenuBar from "./MenuBar";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class TrackIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { match } = this.props;
    return (
      <div className="width100">
        {match && (match.path == "/track" || match.path == "/app/track") && <MenuBar match={match} />}
        <Switch>
          <Route exact path={`${match.path}/holiday`} component={Holiday} />
          <Route exact path={`${match.path}/holiday/selectoptionalholiday`} component={SelectHoliday} />
          <Route path={`${match.path}/leave/dashboard`} component={LeaveDashboard} />
          <Route path={`${match.path}/attendance/dashboard`} component={AttendanceDashboard} />
          <Route path={`${match.path}/attendance`} component={Attendance} />
          <Route path={`${match.path}/leave`} component={Leaves} />
          <Route path={`${match.path}/biometric`} component={BioMetric} />
          <Route path={`${match.path}/gps`} component={Gps} />
          <Route component={PageNotFound} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(withSnackbar(TrackIndex)));
